import { colorSchemeLight, iconSetQuartzLight, themeQuartz } from 'ag-grid-community';

/**
 * Quartz tuned to the Tailwind tokens in `index.css` so AG Grid sits alongside the existing
 * Syncfusion grids without a visual seam. Light only — the app has no dark mode today
 * (`tailwind.config.js` declares no `darkMode`).
 */
export const ledgerAgGridTheme = themeQuartz
  .withPart(colorSchemeLight)
  .withPart(iconSetQuartzLight)
  .withParams({
    accentColor: '#0284c7',
    backgroundColor: '#ffffff',
    foregroundColor: '#111827',
    borderColor: '#e5e7eb',
    headerBackgroundColor: '#f9fafb',
    headerTextColor: '#374151',
    headerFontWeight: 600,
    oddRowBackgroundColor: '#fcfcfd',
    rowHoverColor: '#f3f4f6',
    selectedRowBackgroundColor: '#e0f2fe',
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    fontSize: 13,
    headerFontSize: 12,
    rowHeight: 34,
    headerHeight: 38,
    borderRadius: 6,
    wrapperBorderRadius: 8,
  });
